import { createFileRoute, redirect } from "@tanstack/react-router";

// Duplicate of /scarborough-wills-and-estates — the two split Google's signal for
// Scarborough wills searches, so this one folds into the page the Google profile links to.
export const Route = createFileRoute("/wills-and-probate-scarborough")({
  beforeLoad: () => {
    throw redirect({ href: "/scarborough-wills-and-estates", statusCode: 301 });
  },
});
